<template>
  <div>
    <div class="spu-title">
      <custom-breadcrumb/>
    </div>
    <div>
      <el-form :model="form">
        <el-form-item label="Title" :required="true">
          <el-input v-model="form.title" maxlength="120" show-word-limit></el-input>
          <div class="required-form-error" v-show="!form.title">Product title can't be blank</div>

        </el-form-item>
        <el-form-item label="Category" :required="true">
          <br>
          <el-select v-model="form.cateId" filterable placeholder="Please Select Category" style="width:40%">
            <el-option
              v-for="item in categoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="required-form-error" v-show="!form.cateId">Product Category can't be blank</div>
        </el-form-item>
        <el-form-item label="Description" :required="true">
          <div id="editor"></div>
          <!-- <div class="required-form-error" v-show="!descInfo">Product description can't be blank</div> -->

        </el-form-item>
        <el-form-item>
          <div slot="label">
            <p class="is-required"><span style="color: #F56C6C;">*</span>&nbsp;Product Photos</p>
            <p class="sub-title">Product images showcase your product clearly and usually shot on a white background.
              (Ideal Size: Square - 800 x 800 or higher,up to 10 sheets supported)</p>
          </div>

        </el-form-item>

        <div class="pro-photo">
          <el-upload
            :action="uploadApi"
            ref="upload"
            list-type="picture-card"
            accept=".jpeg,.png,.jpg"
            :limit="10"
            :on-preview="handlePictureCardPreview"
            :file-list.sync="spuFilelist"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="required-form-error" v-show="!spuFilelist || spuFilelist.length<1">Product photos can't be blank
          </div>
        </div>

      </el-form>
      <div>
        <div class="variant">
          <div class="variant-title">
            <p>Variant</p>
            <p class="sub-title">Add variants to your product if it comes in more than one option such as size or
              color.</p>
          </div>
          <div>
            <el-table
              ref="table"
              :data="table"
              stripe
            >
              <template v-for="(item,key) in tableColumn">
                <el-table-column v-if="item=='Image'" :key="key" :label="item" width="100">
                  <template slot-scope="scope">
                    <div v-if="item=='Image'" class="tableImage">
                      <el-upload
                        :action="uploadApi"
                        class="avatar-uploader"
                        list-type="picture-card"
                        accept=".jpeg,.png,.jpg"
                        :file-list="skuFileList[scope.$index]"
                        :key="key"
                        :limit="1"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="(file, fileList)=>handleSkuRemove(file,fileList,scope.$index)"
                        :on-success="(response, file, fileList)=>handleSkuSuccess(response,file,fileList,scope.$index)">
                        <img v-if="scope['row'][item]" :src="scope['row'][item]" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Brand SKU ID'" :key="key" :label="item" width="150">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input v-model="scope['row'][item]"></el-input>
                    </div>
                    <div class="required-error" v-show="!scope['row'][item]">Brand SKU ID can't be blank</div>

                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Case'" :key="key" :label="item" width="60">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input
                        oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value<=0){value=1} if(value>100){value=100}"
                        :maxlength="3" :minlength="1" v-model="scope['row'][item]"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Procurement Price($)'" :key="key" :label="item" width="180"
                                 class="cust-table-column">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 70px"
                                oninput="
                                if(value){value=value.replace(/[^0-9.]/g,'')}
                                if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}
                                "
                                @change="(val) => {scope['row'][item] = val || 0}"
                                v-model="scope['row'][item]">
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item==='Wholesale Price($)'" width="180" :key="key" :label="item">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 70px"
                                @input="(event)=>blurFob(event,scope.$index,scope['row'])"
                                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                v-model="scope['row'][item]">
                      </el-input>
                      <div class="required-error" v-show="!scope['row'][item]">Wholesale Price can’t be blank</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item==='Retail Price($)'" width="200" :key="key" :label="item">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 70px"
                                @change="(event)=>blurRetailPriceFob(event,scope.$index,scope['row'])"
                                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                v-model="scope['row'][item]">
                      </el-input>
                    </div>

                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Weight(g)'" :key="key" :label="item" width="90">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input @change="(event)=>blurWeight(event,scope.$index,scope['row'])"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>10000){value=10000}"
                                v-model="scope['row'][item]"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Inventory'" :key="key" :label="item" width="190">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      {{ scope['row'][item] }}
                      <el-button type="text" style="margin-left: 4px;color: #000000;text-decoration: underline;" @click="handleInventory(scope.row.id)">
                        View
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='status'" :key="key" label="Availability" width="180">
                  <template slot-scope="scope">
                    <!-- 上架或下架状态 -->
                    <div class="table-cell-input" v-if="scope['row']['showStatusSelect']">
                      <el-select placeholder="Please Select" :disabled="goodsStatusDb == '0'"
                                 v-model="scope['row'][item]" @change="e=>changeSkuStatus(e,scope['row'],scope.$index)">
                        <el-option
                          v-for="item in skuStatusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>

                    </div>

                    <!-- 已经设置过补货时间 -->
                    <div class="table-cell-input" v-else>
                      <div style="font-size: 12px;color: #FB541C;">Restock by {{ scope['row']['restockDate'] }}</div>
                      <div class="cust-sku-btn" style="text-align: left;">
                        <span @click="resetRestock(scope['row'],scope.$index)">Restock</span>
                        <span @click="scope['row']['tmpStatus']='99'">Change Date</span>
                      </div>
                    </div>

                    <!-- 库存补货时间 -->
                    <div class="set-restock-date" v-show="scope['row']['tmpStatus']=='99' ">
                      <p>Set restock date</p>
                      <el-date-picker
                        v-model="restockDate"
                        style="margin-top: 10px;"
                        type="date"
                        :disabled="goodsStatusDb == '0'"
                        value-format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy"
                      >
                      </el-date-picker>
                      <div class="required-error" v-show="!restockDate">Please set restock date</div>
                      <div class="cust-sku-btn">
                        <span @click="submitRestockDate(scope['row'],scope.$index,false)">Cancel</span>
                        <span @click="submitRestockDate(scope['row'],scope.$index,true)">Save</span>
                      </div>
                    </div>

                    <!-- 下架的SPU,SKU操作上架，需要提示“请先将SPU设置成上架 -->
                    <div class="required-error" v-show="goodsStatusDb == '0'">Please set SPU Active first</div>

                  </template>

                </el-table-column>
                <el-table-column v-else-if=" item=='Dimensions - L/W/H(cm)'" :key="key" :label="item" width="200">
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 50px;"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value>1000){value=1000}"
                                placeholder="Length" v-model="scope['row']['length']"></el-input>
                      <el-input style="width: 50px;"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                                placeholder="Width" v-model="scope['row']['width']"></el-input>
                      <el-input style="width: 50px;"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                                placeholder="High" v-model="scope['row']['height']"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item!=='length' && item!=='width' && item!=='height' && item!=='countryCode'
                              && item!=='serviceFee' && item!=='isDirectlyModifyNetPrice' && item!=='orlNetPrice'
                             && item!=='restockDate'  " :key="key" :label="item" :width="calcWidth(item)">
                  <template slot-scope="scope">
                    <div>{{ scope['row'][item] }}</div>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>

        <div class="content">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Commodity attributes</p>
          <div>
            <el-radio-group @change="changeCommodityAttributes" v-model="form.commodityAttributes">
              <el-radio :label="4">Ordinary</el-radio>
              <el-radio :label="1">Sensitive</el-radio>
              <el-radio :label="2">Cosmetic</el-radio>
              <el-radio :label="3">Apparel</el-radio>
            </el-radio-group>
            <el-checkbox @change="changeIsSpecial" v-show="isAdmin" style="margin-left: 20px" label="Special"
                         name="type" v-model="form.isSpecial"></el-checkbox>
          </div>
        </div>

        <div class="content">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Customs Name</p>
          <div class="flex">
            <div style="margin-right: 20px;">
              <span class="cust-name">SPU Customs Name_cn</span>
              <el-input class="cust-name-input" @keyup.native="inputCnChange" @blur="inputCnChange"
                        @keydown.native="inputCnChange" maxlength="50" show-word-limit
                        v-model="form.cnProductName"></el-input>
            </div>
            <div>
              <span class="cust-name">SPU Customs Name_en</span>
              <el-input class="cust-name-input" maxlength="50" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"
                        show-word-limit v-model="form.enProductName"></el-input>
            </div>
          </div>
        </div>

        <div class="content">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Status</p>
          <el-select placeholder="Please Select" v-model="form.goodsStatus">
            <el-option
              v-for="item in goodsStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="required-form-error" style="margin-top: 13px;" v-if="form['reviewContentList']">
            modify is {{ form['reviewContentList'] | disUpdateAfterValueStatus }}, under review
          </div>
        </div>

      </div>

    </div>
    <div class="button-list" style="margin-top:20px">
      <el-button @click="save" type="primary" class="save-button">
        save
      </el-button>
      <el-button @click="cancel" plain>
        cancel
      </el-button>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
import E from 'wangeditor'
import Sortable from 'sortablejs'
import {getAction, putAction, deleteAction, postAction} from '@/api/manage.js'
import CustomBreadcrumb from '../components/custom-breadcrumb'
// import Vue from 'vue'
export default {
  components: {CustomBreadcrumb},
  data() {
    return {
      form: {
        title: ''
      },
      goodsStatusOptions: [{
        value: '1',
        label: 'Active'
      }, {
        value: '0',
        label: 'Inactive'
      }],
      /**
       *     缺货(0,"Out of stock"),
       *     有货(1,"Active"),
       *     下架(2,"Inactive"),
       */
      skuStatusOptions: [{
        value: '1',
        label: 'Active'
      }, {
        value: '2',
        label: 'Inactive'
      }, {
        value: '0',
        label: 'Out of stock'
      }],
      table: null,
      tableColumn: null,
      editor: null,
      descInfo: null,
      uploadApi: '',
      spuId: '',
      supplierManagementModel: JSON.parse(localStorage.getItem('pro__userInfo')).supplierManagementModel, // 供应商经营模式1入驻 2自营
      dialogImageUrl: '',
      dialogVisible: false,
      isAdmin: false,
      restockDate: '',
      goodsStatusDb: '',
      spuFilelist: [],
      skuFileList: [],
      categoryList: []
    }
  },
  created() {
    this.uploadApi = process.env.API_URL + 'common/image'
    this.getCategoryList()
  },
  filters: {
    disUpdateAfterValue(arr, type) {
      return arr ? arr.filter(f => f['reviewContent'] == type)[0]['reviewValueAfter'] : ''
    },
    disUpdateAfterValueObj(arr, type) {
      return arr ? arr.filter(f => f['reviewContent'] == 'weight')[0] : {}
    },
    disUpdateAfterValueWeight(obj) {
      return obj ? obj['reviewValueAfter'] : ''
    },
    disUpdateAfterValueStatus(obj) {
      let statusCode = obj ? obj[0]['reviewValueAfter'] : ''
      return statusCode == '1' ? 'Active' : 'Inactive'
    }
  },
  async mounted() {
    const {query} = this.$route
    let data = await getAction(`/v0.2/brand/products/goods/${query.goodsId}`)
    this.createEditor(data['result'])

    let roleData = await getAction(`/sp/suppliers/own-brand`)
    this.isAdmin = roleData['result']['model'] === '4'

    // spu图片
    let imgsData = await getAction(`/sp/suppliers/products/goods/${query.goodsId}/images`)
    this.spuFilelist = imgsData['result'].map((itm, i) => {
      const url = itm['img']
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      return {url: url, name: fileName}
    })

    this.spuId = query.goodsId
    await this.initSku()

    this.initDragSort()
  },
  methods: {
    async initSku() {
      let skuData = await getAction(`v0.2/brand/products/goods/${this.spuId}/skus`)
      let skuArr = skuData['result']['tsSkuInfoList']
      let that = this
      skuArr = skuArr.map(sku => {
        // ===============此处需要存储原始数据库的cif\cost价 ，用于后续save方法使用 start=============
        if (sku['Wholesale Price($)']) {
          sku['oldCifPrice'] = sku['Wholesale Price($)']
        }
        if (sku['Retail Price($)']) {
          sku['oldRetailPrice'] = sku['Retail Price($)']
        }
        if (sku['FOB Price($)']) {
          sku['oldFobPrice'] = sku['FOB Price($)']
        }
        // 自营模式
        if (that.supplierManagementModel == '2') {
          // 服务费
          /* let servicePrice = 0
          if(!that.form['isFreeShipping'] && sku['countryCode']!=='US' ){
            servicePrice = sku['serviceFee'] * sku['Weight(g)']
          }
          let costPrice = Number(sku['Cost Price($)'])
          //品牌佣金率
          let commissionRate = (that.form['commissionRate'] ? that.form['commissionRate'] : 1)
          //FOB Price=成本价/(1-佣金率)
          let fobPrice = (costPrice / (1 - commissionRate))

          //SKU建议零售价=FOB Price * 2 + Cross-Boarder Freight （Cross-Boarder Freight为履约服务费）
          sku['FOB Price($)'] = fobPrice.toFixed(2)
          sku['Wholesale Price($)'] = (fobPrice + servicePrice).toFixed(2)
          sku['Retail Price($)'] = (fobPrice * 2 + servicePrice).toFixed(2)
          sku['oldCifPrice'] = sku['Wholesale Price($)']
          sku['oldRetailPrice'] = sku['Retail Price($)']
  */
        }
        // =============== 此处需要存储原始数据库的cif\cost价 ，用于后续save方法使用end =============
        return sku
      })

      this.table = skuData['result']['tsSkuInfoList']
      this.tableColumn = skuData['result']['characterList']

      // sku图片
      if (this.table) {
        let skuFileArr = this.table.map((x, i) => {
          // 有货（即上架）、下架都显示下拉框
          x['showStatusSelect'] = x['status'] == '1' || x['status'] == '2'

          let url = x['Image']
          let fileName = url.substring(url.lastIndexOf('/') + 1)
          let skuTmpArr = []
          skuTmpArr.push({url: url, name: fileName})
          return skuTmpArr
        })
        this.skuFileList = [...skuFileArr]
      }
    },
    async getCategoryList() {
      let response = await getAction('/tsCategory/tsCateInfo/all-list')
      let tempCategoryList = []
      if (response.success) {
        let categoryList = response.result
        if (categoryList) {
          categoryList.forEach((category, index) => {
            let secondCategoryList = category.childrenList
            secondCategoryList.forEach((secondCategory, secondIndex) => {
              let thirdCategoryList = secondCategory.childrenList
              thirdCategoryList.forEach((thirdCategory, thirdIndex) => {
                const categoryObject = {}
                categoryObject.value = thirdCategory.id
                categoryObject.label = category.cateName + ' / ' + secondCategory.cateName + ' / ' + thirdCategory.cateName
                tempCategoryList.push(categoryObject)
              })
            })
          })
        }
        this.categoryList = tempCategoryList
      } else {
        this.$message.warning(response.message)
      }
    },
    createEditor(data) {
      let descInfo = data['descInfo']
      this.descInfo = descInfo
      this.form = data
      this.goodsStatusDb = data['goodsStatus']
      this.editor = new E('#editor')
      this.editor.config.height = 300
      this.editor.create()
      this.editor.txt.html(descInfo)
      this.$nextTick(() => {
        let menuList = document.querySelectorAll('.w-e-menu')
        menuList.forEach((e, i) => {
          e.setAttribute('data-title', '')
        })
      })
    },
    cancel() {
      this.$router.push({
        path: 'Products'
      })
    },
    changeIsSpecial(event) {
      this.handlePrice(event, 'isSpecial')
    },
    changeCommodityAttributes(event) {
      let value = Number(event)
      if (value) {
        this.handlePrice(value, 'commodityAttributes')
      }
    },
    handlePrice(value, type) {
      let params = []
      for (var index = 0; index < this.table.length; index++) {
        const rowSku = this.table[index]
        const param = {}
        param.skuId = rowSku['id']
        param.shippingCountry = rowSku['countryCode']
        param.isFreeShipping = this.form['isFreeShipping']
        param.isSpecial = this.form['isSpecial']
        param.commodityAttributes = this.form['commodityAttributes']
        param.weight = rowSku['Weight(g)']
        // notes 看表格里面有什么字段
        if (this.supplierManagementModel === 2) {
          param.costPrice = rowSku['Cost Price($)']
        } else {
          param.fobPrice = rowSku['FOB Price($)']
        }
        param[type] = value
        params.push(param)
      }
      postAction('/v0.2/brand/skus/price?commissionRate=' + this.form['commissionRate'], params).then(response => {
        if (response.success) {
          const resultList = response.result
          if (resultList) {
            // notes 根据对应的SKUID 把新返回的cif 和 suggest price 进行重新赋值
            const mapWithSkuId = new Map()
            for (var resultIndex = 0; resultIndex < resultList.length; resultIndex++) {
              const resultObject = resultList[resultIndex]
              mapWithSkuId[resultObject['skuId']] = resultObject
            }
            // 将返回组按skuId分组后进行查询
            let tempTable = this.table
            for (var tableIndex = 0; tableIndex < tempTable.length; tableIndex++) {
              const tableObject = tempTable[tableIndex]
              const skuObject = mapWithSkuId[tableObject['id']]
              tableObject['Wholesale Price($)'] = skuObject.cifPrice
              tableObject['Retail Price($)'] = skuObject.suggestedRetailPrice
            }
            this.table = tempTable
          }
        } else {
          this.$message.warning = response.message
        }
      }).catch(err => {
        this.$message.warning = err
      })
    },
    blurWeight(event, index, row) {
      let value = Number(event)
      if (value) {
        this.handleRowPrice(false, row, index, false, value)
      }
    },
    blurWholesalePrice(event, index, row) {
      // let value = Number(event)
      // if (!value) {
      //   value = Number(row['oldFobPrice'])
      //   this.$set(this.table[index], 'FOB Price($)', value)
      // }
    },
    blurFob(event, index, row) {
      // let value = event.target.value
      let value = Number(event)
      if (!value) {
        value = Number(row['oldCifPrice'])
        this.$set(this.table[index], 'Wholesale Price($)', value)
      }

      if (value) {
        this.handleRowPrice(value, row, index, 'fobPrice', false)
        /**
         * 履约服务费=商品重量*0.009 (v1 版本)
         * CIF=FOB+履约服务费
         * Suggested retail price=(CIF*2)+履约服务费
         * 美国发货的商品没有履约服务费，中国发货的商品有履约服务费，且不是免邮
         *
         */
        // let servicePrice = 0
        // if (!this.form['isFreeShipping'] && row['countryCode'] !== 'US') {
        //   servicePrice = row['serviceFee'] * row['Weight(g)']
        // }
        // this.$set(this.table[index], 'Wholesale Price($)', (value + servicePrice).toFixed(2))
        // this.$set(this.table[index], 'Retail Price($)', (value * 2 + servicePrice).toFixed(2))
        // // 品牌入驻模式成本价=FOB*（1-品牌佣金率）
        // let costPrice = value - (this.form['commissionRate'] ? this.form['commissionRate'] : 0) * value
        // this.$set(this.table[index], 'Cost Price($)', (costPrice).toFixed(2))
      }
    },
    blurRetailPriceFob(event, index, row) {
      let value = Number(event)
      if (value) {
        this.$set(this.table[index], 'isDirectlyModifyNetPrice', true)
        this.$set(this.table[index], 'Retail Price($)', value)
      }
      if (!value) {
        value = Number(row['oldRetailPrice'])
        this.$set(this.table[index], 'Retail Price($)', value)
      }
    },
    blurCostPriceFob(event, index, row) {
      let value = Number(event)
      if (value) {
        this.handleRowPrice(value, row, index, 'costPrice', false)
        // 服务费
        // let servicePrice = 0
        // if (!this.form['isFreeShipping'] && row['countryCode'] !== 'US') {
        //   servicePrice = row['serviceFee'] * row['Weight(g)']
        // }
        // // 品牌佣金率
        // let commissionRate = (this.form['commissionRate'] ? this.form['commissionRate'] : 1)
        // // FOB Price=成本价/(1-佣金率)
        // let fobPrice = (value / (1 - commissionRate))

        // // SKU建议零售价=FOB Price * 2 + Cross-Boarder Freight （Cross-Boarder Freight为履约服务费）
        // this.$set(this.table[index], 'FOB Price($)', fobPrice.toFixed(2))
        // this.$set(this.table[index], 'Wholesale Price($)', (fobPrice + servicePrice).toFixed(2))
        // this.$set(this.table[index], 'Retail Price($)', (fobPrice * 2 + servicePrice).toFixed(2))
      }
    },
    handleRowPrice(value, row, index, price, weight) {
      const param = {}
      // notes 初始化
      param.commodityAttributes = this.form['commodityAttributes']
      param.isFreeShipping = this.form['isFreeShipping']
      param.commissionRate = this.form['commissionRate']
      param.isSpecial = this.form['isSpecial']
      param.weight = row['Weight(g)']
      param.skuId = row['id']
      param.shippingCountryCode = row['countryCode']
      if (weight) {
        param.weight = weight
        // 判断当前人物的角色来传什么
        if (this.supplierManagementModel === 2) {
          param.costPrice = row['Cost Price($)']
        } else {
          param.fobPrice = row['FOB Price($)']
        }
      }
      if (price) {
        param[price] = value
      }
      getAction('/v0.2/brand/skus/' + row['id'] + '/price', param).then(response => {
        if (response.success) {
          const result = response.result
          if (result) {
            this.$set(this.table[index], 'Wholesale Price($)', result.cifPrice)
            this.$set(this.table[index], 'Retail Price($)', result.suggestedRetailPrice)
            this.$set(this.table[index], 'FOB Price($)', result.fobPrice)
            this.$set(this.table[index], 'Cost Price($)', result.costPrice)
          }
        } else {
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    async save() {
      if (!this.checkForm()) {
        return
      }

      const {query} = this.$route
      let newSkuList = []
      newSkuList = this.table.map((e, i) => {
        return {
          skuId: e['id'],
          skuImg: e['Image'],
          brandSkuId: e['Brand SKU ID'],
          step: e['Case'],
          fobPrice: e['FOB Price($)'],
          oldCifPrice: e['oldCifPrice'],
          cifPrice: e['Wholesale Price($)'],
          oldRetailPrice: e['oldRetailPrice'],
          retailPrice: e['Retail Price($)'],
          sourcePrice: e['Cost Price($)'],
          length: e['length'],
          width: e['width'],
          height: e['height'],
          weight: e['Weight(g)'],
          inventory: e['Inventory'],
          netPrice: e['Retail Price($)'],
          isDirectlyModifyNetPrice: e['isDirectlyModifyNetPrice'],
          procurementPrice: e['Procurement Price($)']
        }
      })
      let spuImgArr = this.spuFilelist.map((e, i) => {
        return {
          img: e.url,
          seq: (i + 1)
        }
      })
      this.form.descInfo = this.descInfo
      let saveData = {
        tsGoodsInfo: {
          ...this.form
        },
        skuInfoList: newSkuList,
        tsGoodsImgList: spuImgArr
      }
      let changeData = await putAction(`/v0.2/brand/products/goods/${query.goodsId}`, saveData)
      if (!changeData.success) {
        this.$message.warning(changeData.message)
        return
      } else {
        this.$message.success(changeData.message)
      }
      await getAction(`/es/createGoods?goodsId=${query.goodsId}`)
      if (changeData.success) {
        this.$router.push({
          path: 'Products'
        })
      }
    },
    checkForm() {
      this.descInfo = this.editor.txt.html()
      if (!this.form.title || this.spuFilelist.length < 1) {
        return false
      }
      //    1. 如果“品牌上发货地”是美国，不需要填写中英文报关名称；只有中国发货必段需要填写中英文报关名称
      if (this.form.shippingCountry == 'China' && (!this.form.cnProductName || !this.form.enProductName)) {
        return false
      }

      // scope['row']['Retail Price($)']<scope['row']['Wholesale Price($)']
      let tabArr2 = this.table.filter(f => {
        return Number(f['Retail Price($)']) <= Number(f['Wholesale Price($)'])
      })
      if (tabArr2.length > 0) {
        return false
      }
      let tabArr = this.table.filter(f => {
        let brandId = f['Brand SKU ID']
        let wholesalePrice = f['Wholesale Price($)']
        return !brandId || !wholesalePrice
      })
      return !(tabArr.length > 0)
    },
    handleRemove(file, fileList) {
      let newFiles = [...this.spuFilelist]
      this.spuFilelist = newFiles.filter(f => f.uid !== file.uid)
      this.removeImage(file)
    },
    handleSkuRemove(file, fileList, index) {
      let tmpSkuArr = [...this.skuFileList]
      tmpSkuArr[index] = []
      this.skuFileList = tmpSkuArr
      this.$set(this.table[index], 'Image', '')
      this.removeImage(file)
    },
    removeImage(removeUrl) {
      // const url = removeUrl.response ? removeUrl.response.result : removeUrl.url
      // deleteAction('/common/image', { path: url }).then((response) => {
      //   if (response.success) {
      //     this.$message({
      //       message: 'successfully deleted!',
      //       type: 'success'
      //     })
      //   }
      // })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSuccess(response, file, fileList) {
      let url = response.result
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      this.spuFilelist.push({url: url, name: fileName})
    },
    handleSkuSuccess(response, file, fileList, index) {
      let url = response.result
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      // this.spuFilelist.push({url: url, name: fileName});
      // 设置对应行文件路径
      this.$set(this.table[index], 'Image', url)
    },
    inputCnChange(e) {
      let val = e.target.value.replace(/[^\u4E00-\u9FA5]/g, '')
      this.form.cnProductName = val
    },
    async changeSkuStatus(status, row, index) {
      if (status !== '0') {
        let res = await putAction(`/v0.2/brand/sku/${row['id']}/${status}`)
        this.$message.info(res.message)
        this.$set(this.table[index], 'status', status)
      }
      // tmpStatus设置为99，变量为后续判断使用
      this.$set(this.table[index], 'tmpStatus', status == '0' ? '99' : '')
    },
    async submitRestockDate(row, index, isSave) {
      if (isSave) {
        if (!this.restockDate) {
          return
        }

        let res = await putAction(`/v0.2/brand/sku/${row['id']}/0?restockDate=${this.restockDate}`)
        if (res['success']) {
          this.$message.info('successful')
          this.$set(this.table[index], 'status', '0')
          this.$set(this.table[index], 'showStatusSelect', false)
          // 这行代码，是对上面哪行代码的加强，因为有时候不生效。
          await this.initSku()
        } else {
          this.$message.error('fail')
        }
      }
      this.$set(this.table[index], 'tmpStatus', '')
    },
    async resetRestock(row, index) {
      if (this.goodsStatusDb == '0') {
        return
      }
      let res = await putAction(`/v0.2/brand/sku/${row['id']}/1`)
      if (res['success']) {
        this.$message.info('successful')
        this.$set(this.table[index], 'status', '1')
        await this.initSku()
      } else {
        this.$message.error('fail')
      }
    },
    initDragSort() {
      // 支持拖拽排序
      const el = this.$refs.upload.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({oldIndex, newIndex}) => {
          // 交换位置
          const arr = this.spuFilelist
          const page = arr[oldIndex]
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
        }
      })
    },
    // 跳转库存列表页
    handleInventory(id) {
      this.$router.push({path: `sku-inventory?id=${id}`})
    },

    // 自动计算表头宽度
    calcWidth(label) {
      let flexWidth = 0
      for (const char of label) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
          // 如果是英文字符，为字符分配12个单位宽度
          flexWidth += 12
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20
        } else {
          // 其他种类字符，为字符分配15个单位宽度
          flexWidth += 15
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 100
      }
      return flexWidth + 'px'
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-table__cell cell {
  white-space: nowrap;
}

.tableImage {
  width: 80px;
  height: 80px;

  .avatar-uploader {
    height: 78px;
  }

  /deep/ .el-upload--picture-card {
    width: 100%;
    height: 100%;
    line-height: unset;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-icon-plus {
    padding-top: 23px;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

/** 以下是完善重量部分的样式 */
.el-input-number {
  min-width: 90px;
  width: auto;
}

/deep/ .el-input-number--mini .el-input-number__decrease {
  max-width: auto;
  min-width: 20px;
}

/deep/ .el-input-number__increase {
  max-width: auto;
  min-width: 20px;

}

/deep/ .el-input__inner {
  padding-left: 28px;
  padding-right: 28px
}

/** 以下是完善重量部分的样式结束 */
.save-button {
  background: #000000;
  color: #ffffff;
}

/deep/ .w-e-tooltip-item-wrapper {
  display: none;
}

/deep/ .w-e-toolbar {
  margin-top: 20px;
}

/deep/ .el-form-item__label {
  font-weight: 500;
}

.content {
  margin-bottom: 20px;

  p {
    font-weight: 500;
    margin-bottom: 10px;
  }

  .cust-name {
    width: 260px;
    line-height: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .cust-name-input {
    display: inline-block;
    width: 250px;
  }
}

.spu-title {
  padding: 20px 0;
}

.variant {
  margin-bottom: 30px;
}

.variant-title {
  padding: 20px 0;
}

#editor {
  padding-top: 30px;

  /deep/ div {
    z-index: 99 !important;
  }
}

.sub-title {
  color: #8F8F8F;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
}

.pro-photo {
  position: relative;
}

.table-cell-input {
  /deep/ .el-input__inner {
    padding: 0 5px !important;
  }
}

.cust-table-column {
  position: relative;
}

.required-form-error, .required-error {
  font-size: 12px;
  color: #F77073;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
}

.required-error, .set-restock-date {
  position: absolute;
  z-index: 99;
  white-space: nowrap;
}

.set-restock-date {
  z-index: 99999;
  border: 1px solid #E1E1E1;
  border-radius: 5px;
  left: -245px;
  top: -5px;
  padding: 5px 10px;
  background: #FFFFFF;

  p:nth-child(1) {
    color: #262B2F;
    font-size: 14px;
    font-weight: 600;
  }
}

.cust-sku-btn {
  font-size: 12px;
  margin-top: 10px;
  text-align: right;
  font-weight: 600;

  span {
    cursor: pointer;
    text-decoration: underline;
  }

  span:nth-child(1) {
    margin-right: 15px;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/spuDetails/wholesale-spu-detail.vue